import { render, staticRenderFns } from "./PaymentMethodCard.vue?vue&type=template&id=f10c6896&"
import script from "./PaymentMethodCard.vue?vue&type=script&lang=ts&"
export * from "./PaymentMethodCard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports